<ng-container *transloco="let t">
  <div class="info-area d-flex justify-content-between">
    <div class="d-flex flex-grow-1 justify-content-center flex-column">
      @if (showBreadcrumbs && currentWindowWidth >= 1399) {
        <div class="pb-24">
          <app-breadcrumbs [ngClass]="{ 'd-none': currentWindowWidth < 1399 }"/>
        </div>
      }
      <div class="d-flex justify-content-between align-items-end flex-row pb-16 pb-xxl-24">
        <ng-content select="[slot='title-slot']"></ng-content>
        <div class="info-area__left-end d-flex align-items-end">
          <div class="d-flex d-xxl-none">
            <app-share-cta [leagueItem]="currentItem"/>
          </div>
          <div class="d-none d-xxl-flex" *ngIf="showTrailingLocation">
            <ng-container
              *ngTemplateOutlet="locationTemplate; context: { isoCode: currentItem?.isoCode ?? '', city: currentItem?.city ?? '', extraTag: currentItem?.locationExtraTag ?? '' , height: 27 }, "></ng-container>
          </div>
        </div>
      </div>
      @if (currentItemType === CurrentItemType.EVENT) {
      <ul class="square-list square-list--inline">
        @if (currentItem?.sportOne || currentItem?.sportTwo) {
          <li class="text-uppercase fw-semibold trim-text">
            @if (currentItem?.sportOne) {
              <small>{{ t("app.common.sports." + currentItem?.sportOne) }}</small>
            }
            @if (currentItem?.sportOne && currentItem?.sportTwo) {
              {{ ', ' }}
            }
            @if (currentItem?.sportTwo) {
              <small>{{ t("app.common.sports." + currentItem?.sportTwo) }}</small>
            }
          </li>
        }
        @if (currentItem?.leagueName || currentItem?.leagueNameEn || currentItem?.leagueNameSl
        || currentItem?.leagueNameIt) {
          <li class="trim-text">
            <app-language-output [hrLabel]="currentItem?.leagueName" [enLabel]="currentItem?.leagueNameEn"
                                 [itLabel]="currentItem?.leagueNameIt"
                                 [srLabel]="currentItem?.leagueNameSr"
                                 [bsLabel]="currentItem?.leagueNameBs"
                                 [siLabel]="currentItem?.leagueNameSl" [defaultLanguage]="currentItem?.defaultLanguage"
                                 [languages]="languages"/>
            @if (currentItem?.round !== null && currentItem?.round !== undefined) {
              {{ "-" + currentItem?.round }}
            }        </li>
        }
      </ul>
      } @else if (currentItemType === CurrentItemType.LEAGUE) {
        <div class="d-flex justify-content-start justify-content-lg-between flex-column flex-lg-row">
          <ul class="square-list square-list--inline">
            <li class="d-flex align-items-center text-uppercase fw-semibold trim-text">
              {{ currentItem?.sportId ? t('app.common.sports.' + currentItem!.sportId) : "" }}
            </li>
            <li class="d-flex align-items-center text-uppercase trim-text">
              @if(currentItem?.start && currentItem?.end) {
                  {{ currentItem!.start | date:'MMM yyyy' }} - {{ currentItem!.end | date:'MMM yyyy' }}
              }
            </li>
            <li class="d-flex align-items-center text-uppercase trim-text">
              <span>{{ t('league.total.events') }}</span>
              <div class="v-separator"></div>
              <span>{{ currentItem?.events?.length ?? 0 }}</span>
            </li>
            <li class="d-flex align-items-center text-uppercase trim-text">
              <span>{{ t('league.events.to.go') }}</span>
              <div class="v-separator"></div>
              <span>{{ currentItem | leagueEventsToGo }}</span>
            </li>
          </ul>
          <div class="my-3 my-lg-0">
<!--            <app-rounded-button [label]="t('league.register.for.series')"
                                [btnClass]="'rounded-button&#45;&#45;solid'"
                                [isDisabled]="false"/>-->
          </div>
        </div>
      }
      <div class="d-flex d-xxl-none" *ngIf="showTrailingLocation">
        <ng-container
          *ngTemplateOutlet="locationTemplate; context: { isoCode: currentItem?.isoCode ?? '', city: currentItem?.city ?? '', extraTag: currentItem?.locationExtraTag ?? '' , height: 25}"></ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #locationTemplate let-isoCode="isoCode" let-city="city" let-extraTag="extraTag" let-height="height">
  <div class="d-flex align-items-end flex-nowrap pt-3 pt-xxl-0">
    <img src="assets/icons/location-icon.svg" alt="Location" class="location-icon" width="20" [height]="height"
         (click)="onOpenLocation()"/>
    <div
      class="d-inline-flex align-items-start align-items-xl-center flex-row justify-content-start flex-nowrap">
      <span class="ps-2 fs-16">{{ isoCode + ',&nbsp;' }}</span>
      <div class="d-flex">
        <span class="trim-text fs-16">{{ city + " " + extraTag }}</span>
      </div>
    </div>
  </div>
</ng-template>
